<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/URXLJ4/tc-custom/9781426861611.jpg?1705539587086" alt="This image is the cover for the book Warrior's Lady"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warrior's Lady
      </h1>
      <p class="bookDescription body article font2">
        <p>Though a royal command had force-marched Sir Reece Fitzroy and LadyAnne Delasaine down the aisle, a true pairing between him and theethereal Anne would bring disaster to his family. So despite thelady's siren call Reece swore to turn a deaf ear to passion!Destined to be a pawn in her devious brothers' games of power, AnneDelasaine was thunderstruck when their scheming joined her with theone knight who stirred her soul. But would the price for her life withReece prove more than she could pay?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Moore
      </h2>
      
      <p class="authorDescription body article">Margaret Moore actually began her writing career at the age of eight, when she and a friend would make up stories together. She also loved to read and many years later graduated with a Bachelor of Arts degree in English Literature. After reading a romance by Kathleen Woodiwiss, Margaret took a course in popular fiction writing and through that, found Romance Writers of America. Three years later, in 1991, she sold her first historical romance. And the rest, as they say, is history!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cc5b3152